/* eslint-disable react/prop-types */
import React from 'react'
import {
    Input, Icon, Typography, Link
} from '@telus/koodo-ui-kit'

const TermsAndConditions = ({
    textContent,
    showErrors,
    isTermsConditionsChecked,
    onToggle,
    pushClickAnalytics
}) => {
    const s = textContent?.shortTextFields

    return (
        <div className='space-y-4'>
            <div>
                <Typography block variant={{ size: 'h4' }}>
                    {s?.termsConditionsTitle}
                </Typography>
                <Typography block variant={{ size: 'medium' }}>
                    {s?.termsAgreementReviewInfo}
                </Typography>
                <ul className="list-disc list-outside pl-6 mt-2 mb-6 space-y-1 text-black">
                    <li>
                        <Link
                            href={s?.termsAgreementPolicyLink}
                            hrefAttrs={{ target: '_blank', rel: 'noopener noreferrer' }}
                            onPress={() =>
                                pushClickAnalytics({ click_text: s?.termsAgreementPolicy, event_type: 'Terms and Aggrement policy click', target_link: s?.termsAgreementPolicyLink })
                            }
                        >
                            {s?.termsAgreementPolicy}
                        </Link>
                    </li>
                    <li>
                        <Link
                            href={s?.termsAgreementReferLink}
                            hrefAttrs={{ target: '_blank', rel: 'noopener noreferrer' }}
                            onPress={() =>
                                pushClickAnalytics({ click_text: s?.termsAgreementRefer, event_type: 'Terms and Aggrement Refer link click', target_link: s?.termsAgreementReferLink })
                            }
                        >
                            {s?.termsAgreementRefer}
                        </Link>
                    </li>
                </ul>
            </div>
            <div>
                <Input
                    type="checkbox"
                    label={s?.termsAgreement}
                    checked={isTermsConditionsChecked}
                    onChange={onToggle}
                    validation={showErrors && !isTermsConditionsChecked ? 'error' : undefined}
                    tokens={{ labelFontWeight: 600 }}
                    testId="payment-termsCheck"
                    boldCheckboxLabel
                />
            </div>
            <div className="flex flex-col w-full mb-8">
                <Typography variant={{ size: 'medium' }}>
                    {s?.termsAgreementInfo}
                    <Link
                        href={s?.termsAgreementPrivacyLink}
                        hrefAttrs={{ target: '_blank', rel: 'noopener noreferrer' }}
                        onPress={() =>
                            pushClickAnalytics({ click_text: s?.termsAgreementPrivacy, event_type: 'Terms and Aggrement Privacy link click', target_link: s?.termsAgreementPrivacyLink })
                        }
                    >
                        {s?.termsAgreementPrivacy}
                    </Link>
                </Typography>
                {showErrors && !isTermsConditionsChecked && (
                    <div className="flex items-center mt-4">
                        <Icon icon="ExclamationOctagon" variant={{ color: 'danger' }} />
                        <span className="ml-1">
                            <Typography variant={{ size: 'medium', colour: 'danger' }}>
                                {s?.termsError}
                            </Typography>
                        </span>
                    </div>
                )}
            </div>
        </div>
    )
}

export default TermsAndConditions
